import { FC, useEffect } from 'react';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';
import { useDialog } from 'hooks/useDialog';

import ForbiddenDialog from 'components/errorDialog/ForbiddenDialog';
import OfflineDialog from 'components/errorDialog/OfflineDialog';
import UnauthorizedDialog from 'components/errorDialog/UnauthorizedDialog';

import BackendMessageDialog from './BackendMessageDialog';

const ErrorDialog: FC = () => {
  const error = useAppSelector((state: RootState) => state.error);
  const { setDialog, unsetDialog } = useDialog();

  useEffect(() => {
    if (error.unauthorized) {
      setDialog(UnauthorizedDialog, {});
    }
    if (error.forbidden) {
      setDialog(ForbiddenDialog, {});
    }
    if (error.offline) {
      setDialog(OfflineDialog, {});
    }
    if (error.badRequestError) {
      setDialog(BackendMessageDialog, { error: error.badRequestError });
    }
    if (error.unprocessableEntity) {
      setDialog(BackendMessageDialog, { error: error.unprocessableEntity });
    }
  }, [
    error.unauthorized,
    error.unprocessableEntity,
    setDialog,
    error.badRequestError,
    unsetDialog,
    error.forbidden,
    error.offline
  ]);

  return <></>;
};

export default ErrorDialog;
